<template>
    <Dialog  
        :modal="true"
        :dismissableMask="true"
        v-model:visible="showWarningDialog"
        class="dialog-rounded-content modal-lg account-warning-dialog"
        :showHeader="true">

        <template #header>
            <div class="inline-flex items-center justify-center gap-2">
                <h4 class="font-bold whitespace-nowrap">{{ $t('lib_acc_warn_title') }}</h4>
            </div>
        </template>

        <div class="dialog-content">
            <p v-html="$t('lib_acc_warn_p_1')"></p>
            <ul>
                <li v-html="$t('lib_acc_warn_li_1')"></li>
                <li v-html="$t('lib_acc_warn_li_2')"></li>
                <li v-html="$t('lib_acc_warn_li_3')"></li>
            </ul>
            <p class="d-flex gap-2 align-items-center alert alert-warning" role="alert">
                <font-awesome-icon icon="far fa-triangle-exclamation" class="warning-icon"/>
                <span v-html="$t('lib_acc_warn_p_2')"></span>
            </p>
            <p v-html="$t('lib_acc_warn_p_3')"></p>
        </div>

        <template #footer>
            <div class="inline-flex items-center justify-center gap-2">
                <Button label="Close" outlined severity="secondary" @click="showWarningDialog = false" autofocus />
            </div>
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

export default {
    name: 'AccountWarningDialog',
    components: {
        Dialog,
        Button
    },
    data(){
        return {
            showWarningDialog: false
        }
    },
    mounted() {
        const hasBeenDisplayed = sessionStorage.getItem('accountWarning');

        if (!hasBeenDisplayed){
            this.showWarningDialog = true;
            sessionStorage.setItem('accountWarning', 'true');
        }
    },
}

</script>

<style>
.warning-icon{
    /* color: #000; */
    font-size: 30px;
}
</style>